<section>
  <hdi-breadcrumbs [breadcrumbs]="breadcrumbs"></hdi-breadcrumbs>
</section>
<hdi-section>
  <hdi-not-found-box
    [caasData]="errorContent"
    [errorCode]="errorCode"
  ></hdi-not-found-box>
</hdi-section>
